import { Box, IconButton, MenuItem, TextField, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CharCounter from './CharCounter';
import { MAX_CHARS, VERSO_BLOCK_TYPES, VersoBlock, VersoBlockType } from './versoBlocks';

interface VersoBlockEditorProps {
  block: VersoBlock;
  position: number;
  onChange: (patch: Partial<VersoBlock>) => void;
  onRemove: () => void;
}

const fieldSx = { '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontSize: '0.82rem' } };

function VersoBlockEditor({ block, position, onChange, onRemove }: VersoBlockEditorProps) {
  const placeholder = VERSO_BLOCK_TYPES.find(option => option.value === block.type)?.placeholder;

  return (
    <Box sx={{ border: '1px solid', borderColor: 'grey.200', borderRadius: 1.5, p: 1.5, mb: 1, backgroundColor: 'grey.50' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.75 }}>
        <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ fontSize: '0.72rem', letterSpacing: 0.3 }}>
          BLOC {position}
        </Typography>
        <IconButton size="small" onClick={onRemove} sx={{ color: 'error.main', p: 0.25 }}>
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
        <TextField
          select
          size="small"
          label="Type"
          value={block.type}
          onChange={e => onChange({ type: e.target.value as VersoBlockType })}
          sx={{ minWidth: 130, ...fieldSx }}
        >
          {VERSO_BLOCK_TYPES.map(option => (
            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
          ))}
        </TextField>
        <TextField
          fullWidth
          size="small"
          label="Libellé"
          value={block.label}
          onChange={e => onChange({ label: e.target.value.slice(0, MAX_CHARS) })}
          sx={fieldSx}
        />
      </Box>
      <TextField
        fullWidth
        multiline
        rows={2}
        size="small"
        placeholder={placeholder}
        value={block.content}
        onChange={e => onChange({ content: e.target.value.slice(0, MAX_CHARS) })}
        sx={fieldSx}
      />
      <CharCounter count={block.content.length} />
    </Box>
  );
}

export default VersoBlockEditor;
